import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpClientModule} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Libro } from '../modelos/libro';

@Injectable({
    providedIn: 'root'
  })
  export class LibroService {
  
    
    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
  
    constructor(private http:HttpClient) {
  
        
    }

    
    GetById(Cuid:string ):any{

    return this.http.get(environment.URL_BACKEND + 'Libro/ObtenerPorCuid/'+Cuid)
        .pipe(
        retry(1),
        catchError(this.errorHandl)
        )

    }




    errorHandl(error) {
      let errorMessage = '';
      if(error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      console.log(errorMessage);
      return throwError(errorMessage);
    }
     


}